import { toastr } from 'react-redux-toastr';

import axios from 'axios';
import { push } from 'connected-react-router';
import { addDays, endOfDay } from 'date-fns';
import md5 from 'md5';
import { all, takeLatest, put, call } from 'redux-saga/effects';
import moment from 'moment';
import {isMobile} from 'react-device-detect';

import api from '~/services/api';
import {
  Creators as AddressActions,
  Types as AddressTypes,
} from '~/store/ducks/address';
import {
  Creators as AvatarActions,
  Types as AvatarTypes,
} from '~/store/ducks/avatar';
import {
  Creators as OfferActions,
  Types as OfferTypes,
} from '~/store/ducks/offer';
import {
  Creators as BankActions,
  Types as BankTypes,
} from '~/store/ducks/bank';
import {
  Creators as BankAccountActions,
  Types as BankAccountTypes,
} from '~/store/ducks/bankAccount';
import { Creators as CepActions, Types as CepTypes } from '~/store/ducks/cep';
import {
  Creators as CertificateActions,
  Types as CertificateTypes,
} from '~/store/ducks/certificate';
import {
  Creators as CheckoutActions,
  Types as CheckoutTypes,
} from '~/store/ducks/checkout';
import {
  Creators as ChurchActions,
  Types as ChurchTypes,
} from '~/store/ducks/church';
import {
  Creators as CustomizerActions,
  Types as CustomizerTypes,
} from '~/store/ducks/customizer';
import {
  Creators as DefaultEventActions,
  Types as DefaultEventTypes,
} from '~/store/ducks/defaultEvent';
import {
  Creators as DefaultEventScheduleActions,
  Types as DefaultEventScheduleTypes,
} from '~/store/ducks/defaultEventSchedule';
import {
  Creators as EntityActions,
  Types as EntityTypes,
} from '~/store/ducks/entity';
import {
  Creators as EventActions,
  Types as EventTypes,
} from '~/store/ducks/event';
import {
  Creators as ExpiredTitlesActions,
  Types as ExpiredTitlesTypes,
} from '~/store/ducks/expired_titles';
import {
  Creators as ExportExcelActions,
  Types as ExportExcelTypes,
} from '~/store/ducks/exportExcel';
import {
  Creators as InviteActions,
  Types as InviteTypes,
} from '~/store/ducks/invite';
import {
  Creators as LessonActions,
  Types as LessonTypes,
} from '~/store/ducks/lesson';
import {
  Creators as LessonReportActions,
  Types as LessonReportTypes,
} from '~/store/ducks/lessonReport';
import { Creators as LogActions, Types as LogTypes } from '~/store/ducks/log';
import {
  Creators as LoginActions,
  Types as LoginTypes,
} from '~/store/ducks/login';
import {
  Creators as MinisteryActions,
  Types as MinisteryTypes,
} from '~/store/ducks/ministery';
import {
  Creators as NewsActions,
  Types as NewsTypes,
} from '~/store/ducks/news';
import {
  Creators as OrderActions,
  Types as OrderTypes,
} from '~/store/ducks/order';
import {
  Creators as OrganizationActions,
  Types as OrganizationTypes,
} from '~/store/ducks/organization';
import {
  Creators as OrganizatorActions,
  Types as OrganizatorTypes,
} from '~/store/ducks/organizator';
import {
  Creators as ParticipantActions,
  Types as ParticipantTypes,
} from '~/store/ducks/participant';
import {
  Creators as ProfileActions,
  Types as ProfileTypes,
} from '~/store/ducks/profile';
import {
  Creators as RelationshipActions,
  Types as RelationshipTypes,
} from '~/store/ducks/relationship';
import {
  Creators as ResetPasswordActions,
  Types as ResetPasswordTypes,
} from '~/store/ducks/resetPassword';
import {
  Creators as ScheduleActions,
  Types as ScheduleTypes,
} from '~/store/ducks/schedule';
import {
  Creators as SearchChurchActions,
  Types as SearchChurchTypes,
} from '~/store/ducks/searchChurch';
import {
  Creators as ShippingActions,
  Types as ShippingTypes,
} from '~/store/ducks/shipping';
import {
  Creators as ShippingTagActions,
  Types as ShippingTagTypes,
} from '~/store/ducks/shippingTag';
import {
  Creators as SignupActions,
  Types as SignupTypes,
} from '~/store/ducks/signup';
import {
  Creators as SiteEventActions,
  Types as SiteEventTypes,
} from '~/store/ducks/siteEvent';

const apiKey = process.env.REACT_APP_PAYU_API_KEY;
const apiLogin = process.env.REACT_APP_PAYU_API_LOGIN;
// const publicKey = process.env.REACT_APP_PAYU_PUBLIC_KEY;
const merchantId = process.env.REACT_APP_PAYU_MERCHANT_ID;
const accountId = process.env.REACT_APP_PAYU_ACCOUNT_ID;



function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function* signup(action) {
  try {
    const {
      entity_company,
      name,
      email,
      cpf_cnpj,
      password,
      is_foreign,
      phone,
    } = action.payload;

    if (entity_company === 'pf') {
      yield call(api.post, '/entity', {
        name,
        email,
        cpf: cpf_cnpj,
        password,
        is_foreign,
        phone,
      });
    } else {
      yield call(api.post, '/organization', {
        corporate_name: name,
        email,
        cnpj: cpf_cnpj,
        password,
        phone,
      });
    }

    // yield call(api.post, '/user', {
    //   user_type: entity_company,
    //   name,
    //   email,
    //   cpf_cnpj: cpf_cnpj,
    //   password,
    // });

    yield put(SignupActions.signupSuccess());

    if (entity_company === 'pf') {
      yield put(push('/acesso-pf'));
    } else {
      yield put(push('/acesso-pj'));
    }
    toastr.success('Sucesso!', 'Cadastro realizado com sucesso.');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(SignupActions.signupFailure());
    } else if (
      err.response.data &&
      err.response.data[0] &&
      err.response.data[0].message
    ) {
      toastr.error(
        'Falha!',
        capitalizeFirstLetter(err.response.data[0].message)
      );
      yield put(SignupActions.signupFailure());
    } else {
      toastr.error('Falha!', 'Tente cadastrar novamente.');
      yield put(SignupActions.signupFailure());
    }
  }
}

function formatDate(inputDate) {
  let date, month, year;

  date  = inputDate.getDate();
  month = inputDate.getMonth() + 1;
  year  = inputDate.getFullYear();

    date = date
        .toString()
        .padStart(2, '0');

    month = month
        .toString()
        .padStart(2, '0');

  return `${date}.${month}.${year}`;
}

function* login(action) {
  try {
    const { type, email_cpf_cnpj, password } = action.payload;

    const response = yield call(
      api.post,
      `${type === 'entity' ? '/sessions' : '/organization_sessions'}`,
      {
        email_cpf_cnpj,
        password,
      }
    );

    const { token, user } = response.data;

    if (!response.data.expired) {
      yield put(LoginActions.loginSuccess(response.data));

      localStorage.setItem('@dashboard/token', token.token);
      localStorage.setItem('@dashboard/user', user.id);
      localStorage.setItem('@dashboard/user_type', type);
      localStorage.setItem('@dashboard/privacy_policy', user.privacy_policy);

      yield put(push('/dashboard'));

      if (type === 'entity') {
        toastr.success(
          'Sucesso!',
          `Seja bem-vindo(a) ${user.name.split(' ')[0]}.`
        );
      } else {
        toastr.success(
          'Sucesso!',
          `Seja bem-vindo ${user.corporate_name.split(' ')[0]}.`
        );
      }
    } else {
      yield put(LoginActions.loginFailure(email_cpf_cnpj));

      yield put(push('/senha-expirada'));
      toastr.warning(
        response.data.expired.title,
        response.data.expired.message
      );
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(LoginActions.loginFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(LoginActions.loginFailure());
    }
  }
}

function* acceptPrivacy (action)
{

}

function* resetPassword(action) {
  try {
    const { type, email_cpf_cnpj } = action.payload;
    var url = window.location.protocol+'//'+window.location.host;

    let response;

    if (type === 'entity') {
      response = yield call(api.post, '/forgot_password', {
        email_cpf_cnpj,
        redirect_url: url+'/resetar-senha-pf',
      });
    } else if (type === 'organization') {
      response = yield call(api.post, '/forgot_password_pj', {
        email_cpf_cnpj,
        redirect_url: url+'/resetar-senha-pj',
      });
    } 

    const { email } = response.data;

    yield put(ResetPasswordActions.resetPasswordSuccess());

    yield put(push('/'));
    toastr.success('Boa!', `Acesse o email ${email}`);
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ResetPasswordActions.resetPasswordFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(ResetPasswordActions.resetPasswordFailure());
    }
  }
}

function* confirmResetPassword(action) {
  try {
    const { type, token, password } = action.payload;

    if (type === 'entity') {
      yield call(api.put, '/forgot_password', {
        token,
        password,
      });
    } else {
      yield call(api.put, '/forgot_password_pj', {
        token,
        password,
      });
    }

    yield put(ResetPasswordActions.confirmResetPasswordSuccess());

    yield put(push('/'));
    toastr.success('Parabéns!', 'A senha foi alterada com sucesso');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ResetPasswordActions.confirmResetPasswordFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(ResetPasswordActions.confirmResetPasswordFailure());
    }
  }
}

function* changePassword(action) {
  try {
    const { data } = action.payload;

    const user_id = localStorage.getItem('@dashboard/user');

    if (data.user_type === 'entity') {
      const { entity_id: id } = data;
      delete data.entity_id;

      if (id) {
        yield call(api.put, `/change_password/${id}/${data.user_type}`, data);
      } else {
        yield call(
          api.put,
          `/change_password/${user_id}/${data.user_type}`,
          data
        );
      }
    } else {
      const { organization_id: id } = data;
      delete data.organization_id;

      if (id) {
        yield call(api.put, `/change_password/${id}/${data.user_type}`, data);
      } else {
        yield call(
          api.put,
          `/change_password/${user_id}/${data.user_type}`,
          data
        );
      }
    }

    yield put(ProfileActions.passwordProfileSuccess());
    toastr.confirm('Senha atualizada com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente novamente mais tarde.');
      yield put(ProfileActions.passwordProfileFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(ProfileActions.passwordProfileFailure());
    }
  }
}

function* healthcheck() {
  try {
    let response =  yield call(api.get, `/healthcheck`);   
    console.log(response);
    throw {status: 500, message: 'detailed message'};
  } catch (err) {
    throw 500; 
  }
}

function* logout() {
  try {
    localStorage.removeItem('@dashboard/token');
    localStorage.removeItem('@dashboard/user');
    localStorage.removeItem('@dashboard/user_type');
    localStorage.removeItem('@dashboard/admin_events_filter');
    localStorage.removeItem('@dashboard/admin_events_page');
    localStorage.removeItem('@dashboard/admin_events_sorted');
    localStorage.removeItem('@dashboard/admin_entities_filter');
    localStorage.removeItem('@dashboard/admin_entities_page');
    localStorage.removeItem('@dashboard/admin_entities_sorted');

    yield put(push('/'));
    toastr.success('Desconectado!', 'Estamos ansiosos para você voltar.');

    yield put(LoginActions.logoutSuccess());
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(LoginActions.logoutFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(LoginActions.logoutFailure());
    }
  }
}

function* profile() {
  try {
    const user_type = localStorage.getItem('@dashboard/user_type');

    const response = yield call(api.get, `/sessions/${user_type}`);

    yield put(ProfileActions.profileSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ProfileActions.profileFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao carregar os seus dados.');
      yield put(ProfileActions.profileFailure());
    }
  }
}

function* expiredTitles(action) {
  try {
    const { cpf } = action.payload;

    const response = yield call(api.get, `/expired_titles/${cpf}`);

    yield put(
      ExpiredTitlesActions.expiredTitlesSuccess(response.data.expired_titles)
    );
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ExpiredTitlesActions.expiredTitlesFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao carregar os seus dados.');
      yield put(ExpiredTitlesActions.expiredTitlesFailure());
    }
  }
}

function* address(action) {
  try {
    const {
      user_id,
      user_type,
      addressesPost,
      addressesPut,
    } = action.payload;

    yield call(api.post, '/address', {
      user_id,
      user_type,
      addressesPost,
      addressesPut,
    });

    yield put(AddressActions.addressSuccess());
    toastr.success('Sucesso!', 'Seus endereços foram atualizados.');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(AddressActions.addressFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao atualizar seus endereços.');
      yield put(AddressActions.addressFailure());
    }
  }
}

function* deleteAddress(action) {
  try {
    const { id, index, user_id } = action.payload;

    yield call(api.delete, `/address/${id}/${index}/${user_id}`);

    yield put(AddressActions.addressSuccess());
    toastr.success('Sucesso!', 'O endereço foi removido.');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(AddressActions.addressFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao remover o endereço.');
      yield put(AddressActions.addressFailure());
    }
  }
}

function* bank() {
  try {
    const response = yield call(api.get, '/banks');

    yield put(BankActions.bankSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(BankActions.bankFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao visualizar os bancos.');
      yield put(BankActions.bankFailure());
    }
  }
}

function* bankAccount(action) {
  try {
    const {
      netsuite_id,
      user_type,
      bankAccountsPost,
      bankAccountsPut,
    } = action.payload;

    yield call(api.post, '/bank_account', {
      netsuite_id,
      user_type,
      bankAccountsPost,
      bankAccountsPut,
    });

    yield put(BankAccountActions.bankAccountSuccess());
    toastr.success('Sucesso!', 'Suas contas foram atualizadas.');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(BankAccountActions.bankAccountFailure());
    } else {
      toastr.error(
        'Falha!',
        'Houve um erro ao atualizar suas contas bancárias.'
      );
      yield put(BankAccountActions.bankAccountFailure());
    }
  }
}

function* deleteBankAccount(action) {
  try {
    const { id } = action.payload;

    yield call(api.delete, `/bank_account/${id}`);

    yield put(BankAccountActions.deleteBankAccountSuccess());
    toastr.success('Sucesso!', 'A conta bancária foi removida.');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(BankAccountActions.deleteBankAccountFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao remover a conta bancária.');
      yield put(BankAccountActions.deleteBankAccountFailure());
    }
  }
}

function* scheduleEvents(action) {
  try {
    const { schedulesPost, schedulesPut } = action.payload;

    yield call(api.post, '/event_schedule', {
      schedulesPost,
      schedulesPut,
    });

    yield put(ScheduleActions.scheduleSuccess());
    toastr.success('Sucesso!', 'Seus cronogramas foram atualizados.');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ScheduleActions.scheduleFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao atualizar os cronogramas.');
      yield put(ScheduleActions.scheduleFailure());
    }
  }
}

function* deleteSchedule(action) {
  try {
    const { id } = action.payload;

    yield call(api.delete, `/schedule/${id}`);

    yield put(ScheduleActions.deleteScheduleSuccess());
    toastr.success('Sucesso!', 'O cronograma foi removida.');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ScheduleActions.deleteScheduleFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao remover o cronograma.');
      yield put(ScheduleActions.deleteScheduleFailure());
    }
  }
}

function* updatePhoneParticipant(action) {
  try {
    const { phone, cpf, id } = action.payload;
    if (id) {
      yield call(api.put, `/entity/${id}`, {'phone':phone});
    }
    yield put(ProfileActions.editProfileSuccess());
    toastr.confirm('Telefone atualizado com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ProfileActions.editProfileFailure());
    } else {
      const { data } = err.response;

      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.map(error => {
          toastr.error('Falha!', error.message);
        });
      }

      yield put(ProfileActions.editProfileFailure());
    }
  }
}


function* editProfile(action) {
  try {
    const { data } = action.payload;
    const { entity_id: id } = data;
    delete data.entity_id;

    const user_type = localStorage.getItem('@dashboard/user_type');
    const user_id   = localStorage.getItem('@dashboard/user');

    if (id) {
      yield call(api.put, `/entity/${id}`, data);
    } else {
      yield call(
        api.put,
        `${
          user_type === 'entity'
            ? `/entity/${user_id}`
            : `/organization/${user_id}`
        }`,
        data
      );
    }

    yield put(ProfileActions.editProfileSuccess());    

    if(typeof data.privacy_policy == "boolean" && (data.privacy_policy === true || data.privacy_policy === false) ){
      localStorage.setItem('@dashboard/privacy_policy', data.privacy_policy);
    }
      
    toastr.confirm('Perfil atualizado com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ProfileActions.editProfileFailure());
    } else {
      const { data } = err.response;

      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.map(error => {
          toastr.error('Falha!', error.message);
        });
      }

      yield put(ProfileActions.editProfileFailure());
    }
  }
}

function* churchs(action) {
  try {
    const { uf, city, name, cnpj } = action.payload.data;

    const response = yield call(api.post, '/organization_params', {
      uf,
      city,
      name,
      cnpj
    });

    yield put(ChurchActions.churchSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente novamente mais tarde.');
      yield put(ChurchActions.churchFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(ChurchActions.churchFailure());
    }
  }
}

function* entities(action) {
  try {
    const { id, cpf, email, name } = action.payload.data;

    const response = yield call(api.post, '/entity_params', {
      id,
      cpf,
      email,
      name,
    });

    yield put(EntityActions.searchEntitySuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente novamente mais tarde.');
      yield put(EntityActions.searchEntityFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(EntityActions.searchEntityFailure());
    }
  }
}

function* event(action) {
  try {
    const { id } = action.payload;
    const response = yield call(api.get, `/event/${id}`);
    yield put(EventActions.eventSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EventActions.eventFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao carregar os dados do evento.');
      yield put(EventActions.eventFailure());
    }
  }
}

function* allEvents() {
  try {
    const user_id = localStorage.getItem('@dashboard/user');
    const user_type = localStorage.getItem('@dashboard/user_type');

    const response = yield call(
      api.get,
      `/${user_type === 'entity' ? 'entity' : 'organization'}/${user_id}`
    );

    yield put(EventActions.allEventSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EventActions.allEventFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao carregar os eventos.');
      yield put(EventActions.allEventFailure());
    }
  }
}

// function* defaultEventSchedule(action) {
//   try {
//     const { id } = action.payload;

//     const response = yield call(api.get, `/default_event_schedules/${id}`);

//     yield put(EventActions.allEventSuccess(response.data));
//   } catch (err) {
//     if (err.message === 'Network Error') {
//       toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
//       yield put(EventActions.allEventFailure());
//     } else {
//       toastr.error('Falha!', 'Houve um erro ao carregar os eventos.');
//       yield put(EventActions.allEventFailure());
//     }
//   }
// }

function* consultEntity(action) {
  try {
    const { id } = action.payload;

    const response = yield call(api.get, `/entity/${id}`);
    // const response = yield call(api.get, `/user/${id}`);

    yield put(EntityActions.entitySuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EntityActions.entityFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao carregar os seus dados.');
      yield put(EntityActions.entityFailure());
    }
  }
}

function* consultEntityCpf(action) {
  try {
    const { cpf, profile_id } = action.payload;

    const response = yield call(api.get, `/entity/cpf/${cpf}/${profile_id}`);
    // const response = yield call(api.get, `/user/cpf/${cpf}/${profile_id}`);

    yield put(EntityActions.entityCpfSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EntityActions.entityCpfFailure(false));
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      if (err.response.data.type === 'not_found') {
        yield put(EntityActions.entityCpfFailure(true));
      } else {
        yield put(EntityActions.entityCpfFailure(false));
      }
    }
  }
}

function* checkPolicy(action) {
  try {
    const { privacy_policy } = action.payload
    const id = localStorage.getItem('@dashboard/user');  
    const response = yield call(api.post, `/entity/check_policy/${id}`);

    yield put(EntityActions.entityPolicySuccess(true));
    localStorage.setItem('@dashboard/privacy_policy', true);
    
    toastr.confirm('Aceite da Política de Privacidade atualizado com sucesso!', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });


  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EntityActions.entityPolicyFailure(false));
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      if (err.response.data.type === 'error_policy') {
        yield put(EntityActions.entityPolicyFailure(true));
      } else {
        yield put(EntityActions.entityPolicyFailure(false));
      }
    }
  }
}

function* allConsultOrders(action) {
  try {
    const { page, filterData, sorted } = action.payload;

    const response = yield call(api.post, '/order_paginate', {
      page,
      filterData,
      sorted,
    });
    yield put(OrderActions.allConsultOrdersSuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(OrderActions.allConsultOrdersFailure());
  }
}

function* allConsultEntities(action) {
  try {
    let response;
    const { page, filterData, sorted } = action.payload;

    if (filterData.entity_type === 'pf') {
      response = yield call(api.post, '/entity_paginate', {
        page,
        filterData,
        sorted,
      });
    } else {
      response = yield call(api.post, '/organization_paginate', {
        page,
        filterData,
        sorted,
      });
    }

    yield put(EntityActions.allConsultEntitiesSuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(EntityActions.allConsultEntitiesFailure());
  }
}

function* allConsultEvent(action) {
  try {
    const { page, filterData, sorted } = action.payload;

    const response = yield call(api.post, '/event_paginate', {
      page,
      filterData,
      sorted,
    });

    yield put(EventActions.allConsultEventSuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(EventActions.allConsultEventFailure());
  }
}

function* exportExcel(action) {
  try {
    const { lastPage, filterData } = action.payload;

    const headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Accept',
    };

    const response = yield call(
      api.post,
      '/event_export_excel',
      {
        withCredentials: true,
        timeout: 1000 * 1000,
        lastPage,
        filterData,
      },
      {
        headers,
      }
    );

    yield put(ExportExcelActions.exportExcelSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ExportExcelActions.exportExcelFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(ExportExcelActions.exportExcelFailure());
    }
  }
}
function* entityExportExcel(action) {
  try {
    const { lastPage, filterData } = action.payload;

    const headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Accept',
    };

    const response = yield call(
      api.post,
      '/entity_export_excel',
      {
        withCredentials: true,
        timeout: 1000 * 1000,
        lastPage,
        filterData,
      },
      {
        headers,
      }
    );

    yield put(ExportExcelActions.exportExcelEntitySuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ExportExcelActions.exportExcelEntityFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(ExportExcelActions.exportExcelEntityFailure());
    }
  }
}

function* organizationExportExcel(action) {
  try {
    const { lastPage, filterData } = action.payload;

    const headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Accept',
    };

    const response = yield call(
      api.post,
      '/organization_export_excel',
      {
        withCredentials: true,
        timeout: 1000 * 1000,
        lastPage,
        filterData,
      },
      {
        headers,
      }
    );

    yield put(ExportExcelActions.exportExcelOrganizationSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ExportExcelActions.exportExcelOrganizationFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(ExportExcelActions.exportExcelOrganizationFailure());
    }
  }
}
function* allEventForAdminPrint(action) {
  try {
    const { page, filterPrintData } = action.payload;

    const response = yield call(api.post, '/event_for_print_certificate', {
      page,
      filterPrintData,
    });

    yield put(
      EventActions.allConsultEventForPrintCertificateSuccess(response.data)
    );
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(EventActions.allConsultEventForPrintCertificateFailure());
  }
}

function* addInvite(action) {
  try {
    const { event_id, event_type, name, email, is_buyer } = action.payload;

    yield call(api.post, '/invite', {
      event_id,
      event_type,
      name,
      email,
      is_buyer,
    });

    yield put(InviteActions.inviteSuccess());

    toastr.confirm('Convite enviado com sucesso', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(InviteActions.inviteFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao enviar o convite.');
      yield put(InviteActions.inviteFailure());
    }
  }
}

function* confirmInvite(action) {
  try {
    const { data } = action.payload;
    const { invite_id, entity_id, event_id, assistant } = data;
    const user_data ={
      privacy_policy: data.privacy_policy,
      mailing: data.mailing
    }

    const response = yield call(api.post, '/event_participant', {
      entity_id,
      event_id,
      assistant,
      order_id: null,
    });

    const response_user = yield call(api.put, `/entity/${entity_id}`, user_data)

    if (response.data.error) {
      yield put(ParticipantActions.addParticipantFailure());
      yield put(InviteActions.confirmInviteFailure());
      toastr.error(response.data.error.title, response.data.error.message);
    } else {
      yield put(ParticipantActions.addParticipantSuccess());

      if(invite_id){
      yield call(api.delete, `/invite/${invite_id}`);
      yield put(InviteActions.deleteInviteSuccess());
      }

      yield put(InviteActions.confirmInviteSuccess());
      yield put(EventActions.eventSuccess(null));

      yield put(
        push(`/evento/${event_id}/convite/${entity_id}/confirmacao/sucesso`)
      );
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(InviteActions.confirmInviteFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao confirmar o convite.');
      yield put(InviteActions.confirmInviteFailure());
    }
  }
}

function* deleteInvite(action) {
  try {
    const { invite_id } = action.payload;

    yield call(api.delete, `/invite/${invite_id}`);

    yield put(InviteActions.deleteInviteSuccess());
    window.location.reload();
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(InviteActions.deleteInviteFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao remover o convite.');
      yield put(InviteActions.deleteInviteFailure());
    }
  }
}


function paymentInfo (data){
  const {
    user,
    card,
    pix,
    forceVista,
    shipping_address,
  } = data;

  const endOfCurrentDay = endOfDay(new Date());
  let expirationDateAux = null;

  if (data.order_details.order_type === 'Curso' && !user.cnpj) {
    expirationDateAux = addDays(endOfCurrentDay, 3);
    data.boleto_a_vista = true;
  } else {
    expirationDateAux = addDays(endOfCurrentDay, 3);
    data.boleto_a_vista = true;
    
    if (data.order_details.amount > 1100 && !forceVista) {
      expirationDateAux = addDays(endOfCurrentDay, 30);
      data.boleto_a_vista = false;
    }
  }

try{
  if (pix) {
    data.payment_info= {  
      "MerchantOrderId":"NOVO",
      "Customer":
      {  
          "Name":  user.corporate_name? user.corporate_name : user.name,
          "Identity": user.cpf ? user.cpf : user.cnpj,
          "IdentityType":"CPF",
          "Email": user.email         
      },
      "Payment":
      {  
        "Type":"Pix",
        "Amount":Number(data.order_details.amount)*100    
      }  
    }  
  }
  else if (card === null) {
    data.payment_info =
    {
      "numeroConvenio": 2997290,
      "dataEmissao": formatDate(endOfCurrentDay),
      "dataVencimento": formatDate(expirationDateAux),
      "valorOriginal": Number(data.order_details.amount),
      "numeroCarteira": 17,
      "numeroVariacaoCarteira": 19,
      "codigoModalidade": 1,
      "codigoAceite": "N",
      "codigoTipoTitulo": 2,
      "indicadorPermissaoRecebimentoParcial": "N",
      "indicadorPix":"N",
      "numeroTituloCliente": "0002997290",
      "pagador": {
        "tipoInscricao": user.cnpj ? 2 : 1,
        "numeroInscricao":user.cpf ? user.cpf : user.cnpj,
        "nome": user.corporate_name? user.corporate_name : user.name,
        "endereco": shipping_address.street + "," +shipping_address.street_number,
        "cep": shipping_address.cep,
        "cidade": shipping_address.city,
        "bairro": shipping_address.neighborhood,
        "uf": shipping_address.uf
      }
    };
  } else {
    const formattedCardNumber = card.number.replace(/ /g, '');
    const [month, year] = card.expiry.split('/');
    const formattedCardExpiry = `${month}/20${year}`;


    data.payment_info= {  
      "MerchantOrderId":"NOVO",
      "Customer":
      {  
          "Name": card.name,
          "Identity": card.cpf_card,
          "IdentityType":"CPF",
          "Email": user.email,
          "Address":
          {
            "Street": shipping_address.street,
            "Number": shipping_address.street_number,  
            "Complement": shipping_address.complement,
            "ZipCode" : shipping_address.cep,
            "District": shipping_address.neighborhood,
            "City": shipping_address.city,
            "State" :shipping_address.uf,
            "Country": "BRA"
          }
      },
      "Payment":
      {  
        "Type":"CreditCard",
        "Amount":Number(data.order_details.amount)*100,
        "Currency":"BRL",
        "Country":"BRA",
        "ServiceTaxAmount":0,
        "Installments":data.order_details.installments,
        "Interest":"ByMerchant",
        "Capture":true,
        "Authenticate":false,    
        "Recurrent": false,
        "SoftDescriptor":"UDF",
        "CreditCard":{  
            "CardNumber":formattedCardNumber,
            "Holder":card.name,
            "ExpirationDate":formattedCardExpiry,
            "SecurityCode":card.cvc,
            "SaveCard":"false",
            "Brand": card.issuer.toLowerCase() === 'mastercard' ? 'master' : (card.issuer === 'dinersclub' ? 'diners' : card.issuer)
        }
      }  
    }     

  }   
}catch(err)
{
  console.log(err)
}   

  return data.payment_info;

}

function updateUser(){

}

function* loadPayment(action) {
  try {
    const data = action.payload;
    let startDate = data.allPayments[0].order_date.split(' ')[0];
    let endDate   = data.allPayments[0].order_date.split(' ')[0];
  
    data.allPayments.forEach(payment => {
      const dataAtual = payment.order_date.split(' ')[0] ;
      payment.order_date = payment.order_date.split(' ')[0];

      if (!isNaN(payment.value)) {
        payment.value =  payment.value.toString().replace('.',',') ;
      }
     
      console.log(dataAtual);
      if (moment(dataAtual,'DD/MM/YYYY').isBefore(moment(startDate,'DD/MM/YYYY'))) {
        startDate = dataAtual;
      }
      if (moment(dataAtual,'DD/MM/YYYY').isAfter(moment(endDate,'DD/MM/YYYY'))) {
        endDate = dataAtual;
      }
    })

    data.startDate = startDate;
    data.endDate = endDate;
    console.log(startDate + '-' + endDate);

    const response = yield call(api.post, `/load_payments`, data);
    yield put(OrderActions.loadPaymentSuccess(response.data));
  } catch (err) {
      console.log(JSON.stringify(err))
      toastr.error('Falha!', 'Não conseguimos conexão para fazer upload dos pagamentos.');
      yield put(OrderActions.loadPaymentFailure(false));   
  }  
}

function* checkPayment(action) {
  try {
    const {payment_id} = action.payload;
    const response = yield call(api.get, `/check_payment/${payment_id}`);
    yield put(OrderActions.checkPaymentSuccess(response.data));
  } catch (err) {
      toastr.error('Falha!', 'Não conseguimos conexão para checar o status do pagamento.');
      yield put(OrderActions.checkPaymentFailure(false));   
  }  
}
// checkpoint
function* confirmParticipantInviteOrder(action) {
  try {
    const { data } = action.payload;
    const {user,couple_user,event_id, assistant, card,pix,shipping_address} = data;
   
    data.boleto_a_vista = true;
    data.order_details.amount = data.order_details.amount.toFixed(2);
    let addresses = [shipping_address];
   
    yield put(ParticipantActions.addParticipantSuccess());

    const formattedPhone = data.shipping_address.phone
      .replace('+55', '')
      .replace('+', '')
      .replace(' ', '')
      .replace('(', '')
      .replace(')', '')
      .replace('-', '');

    const user_type = data.invite
      ? 'entity'
      : localStorage.getItem('@dashboard/user_type');

    const user_data ={
      phone: formattedPhone,
      privacy_policy: user.privacy_policy,
      mailing: user.mailing,
      name: user.name
    }

    if(user.id && user.addresses_input)
    {
      user_data.addresses = [{
        "type":addresses[0].address_type,
        "other_type_name": addresses[0].address_other_type_name,
        "cep":addresses[0].cep,
        "uf":addresses[0].uf,
        "city":addresses[0].city,
        "neighborhood":addresses[0].neighborhood,
        "street":addresses[0].street,
        "street_number":addresses[0].street_number,
        "complement":addresses[0].complement,
        "receiver":addresses[0].receiver,
        "receiver_cpf":addresses[0].receiver_cpf,
        "country":"Brasil"
      }];
    }

    if(user.id && user.changed)
    {
      user_data.email = user.email;
    }



    const response_user = yield call(
      api.put,
      `${
        user_type === 'entity'
          ? `/entity/${user.id}`
          : `/organization/${user.id}`
      }`,
      user_data
    );    

    const couple_data ={
      privacy_policy: user.privacy_policy,
      mailing: user.mailing,
      name: couple_user.name
    }

    if(couple_user.id && couple_user.addresses_input)
    {
      couple_data.addresses = [{
        "type":addresses[0].address_type,
        "other_type_name": addresses[0].address_other_type_name,
        "cep":addresses[0].cep,
        "uf":addresses[0].uf,
        "city":addresses[0].city,
        "neighborhood":addresses[0].neighborhood,
        "street":addresses[0].street,
        "street_number":addresses[0].street_number,
        "complement":addresses[0].complement,
        "receiver":addresses[0].receiver,
        "receiver_cpf":addresses[0].receiver_cpf,
        "country":"Brasil"
      }];
    }

    console.log("Dados do couple"+JSON.stringify(couple_data))

    const response_couple_user = yield call(api.put, `/entity/${couple_user.id}`, couple_data)

    if (response_user.data.id) {
      delete data.shipping_address.phone;      

      const toSendOrder = {
        user,
        card,
        pix,
        products: data.products,
        shipping_address,
        shipping_option: data.shipping_option,
        order_details: data.order_details,
        payment_info:paymentInfo(data),
        invite: true,
      };

      const response_order = yield call(api.post, '/order', toSendOrder);
      yield put(OrderActions.addOrderSuccess());

      const response = yield call(api.post, '/inscription_training', {
        entity_id: user.id,
        event_id,
        assistant,
        order_id: response_order.data.id,
      });

      if (couple_user.id === null && couple_user.cpf !== '') {
        const responseCouple = yield call(api.post, '/entity', {
          name: couple_user.name,
          cpf: couple_user.cpf,
          email: couple_user.email,
          addresses:addresses,
          sex: couple_user.sex,
          phone: user.phone,
          password: couple_user.password,
          is_foreign: user.is_foreign,
          privacy_policy: user.privacy_policy,
          mailing: user.mailing,
          invite: true,
        });

        yield put(
          ParticipantActions.createParticipantSuccess(responseCouple.data)
        );

        const created_couple_user = responseCouple.data;

        yield call(api.post, '/inscription_training', {
          entity_id: created_couple_user.id,
          event_id: data.event_id,
          assistant: false,
          order_id: response_order.data.id,
        });
      }

      if (couple_user.id !== null) {
        yield call(api.post, '/inscription_training', {
          entity_id: couple_user.id,
          event_id: data.event_id,
          assistant: false,
          order_id: response_order.data.id,
        });
      }

      if (response_order.data.id) {
    
        toastr.success('Sucesso!', 'Solicitação criada com sucesso!');

        yield call(api.delete, `/invite/${data.invite_id}`);
        yield put(InviteActions.deleteInviteSuccess());

        yield call(api.put, `/event_participant/${response.data.id}`, {
          order_id: response_order.data.id,
        });

        yield put(EventActions.eventSuccess(null));
        
        if (data.pix) {
          yield put(push(`/pedido/${response_order.data.id}/pix`))
        } else if (response_order.data.transaction.boleto_url) {
          window.open(response_order.data.transaction.boleto_url);
          yield put(
            push(`/evento/${data.event_id}/convite/${user.id}/confirmacao/sucesso`)
          );
        } else {
          yield put(
            push(`/evento/${data.event_id}/convite/${user.id}/confirmacao/sucesso`)
          );
        }
      
      } else {
        yield call(
          api.delete,
          `/event_participant/${user.id}/${response.data.id}`
        );

        yield put(OrderActions.addOrderFailure());
      }
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(InviteActions.confirmInviteFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao confirmar o convite.');
      yield put(InviteActions.confirmInviteFailure());
    }
  }
}

function* createByInviteParticipant(action) {
  try {
    const {
      invite_id,
      name,
      cpf,
      email,
      phone,
      sex,
      password,
      is_foreign,
      event_id,
      privacy_policy,
      mailing,   
      shipping_address
    } = action.payload;

    let addresses = [shipping_address];

    const response = yield call(api.post, '/entity', {
      name,
      cpf,
      email,
      phone,
      sex,
      addresses,
      password,
      is_foreign,
      privacy_policy,
      mailing
    });

    const entity_id = response.data.id;
    yield put(ParticipantActions.createParticipantSuccess(response.data));

    yield call(api.post, '/event_participant', {
      entity_id,
      event_id,
      assistant: false,
      order_id: null,
    });

    yield put(ParticipantActions.addParticipantSuccess());

    if(invite_id){
    yield call(api.delete, `/invite/${invite_id}`);
    yield put(InviteActions.deleteInviteSuccess());
    }

    yield put(EventActions.eventSuccess(null));

    yield put(
      push(`/evento/${event_id}/convite/${entity_id}/confirmacao/sucesso`)
    );
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.createParticipantFailure());
    } else {
      const { data } = err.response;

      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.map(error => {
          toastr.error('Falha!', error.message);
        });
      }

      yield put(ParticipantActions.createParticipantFailure());
    }
  }
}

// checkpoint
function* createByInviteOrderParticipant(action) {
  try {
    const { data } = action.payload;
    const { user, couple_user, shipping_address, card, pix } = data;
    data.order_details.amount = data.order_details.amount.toFixed(2);
    data.boleto_a_vista = true;
    let addresses = [shipping_address]

    console.log("Dados da Insercao");

    if (!user.id || user.id === null) {
      const response = yield call(api.post, '/entity', {
        name: user.name,
        cpf: user.cpf,
        email: user.email,
        sex: user.sex,
        phone: user.phone,
        password: user.password,
        addresses:addresses,
        privacy_policy: user.privacy_policy,
        mailing: user.mailing,
        is_foreign: user.is_foreign,
        invite: true,
      });

      console.log("Passou da insercao");

      const created_user = response.data;
      yield put(ParticipantActions.createParticipantSuccess(response.data));
  

      if (response.data.id) {       

        const toSendOrder = {
          user: created_user,
          card,
          pix,
          products: data.products,
          shipping_address,
          shipping_option: data.shipping_option,
          order_details: data.order_details,
          payment_info: paymentInfo(data),
          invite: true,
        };
        console.log("Chamou pedido");
        const response_order = yield call(api.post, '/order', toSendOrder);
        yield put(OrderActions.addOrderSuccess());

        if (response_order.data.id) {
          yield call(api.post, '/inscription_training', {
            entity_id: created_user.id,
            event_id: data.event_id,
            assistant: false,
            order_id: response_order.data.id,
          });

          if (couple_user.id === null && couple_user.cpf !== '') {
            const responseCouple = yield call(api.post, '/entity', {
              name: couple_user.name,
              cpf: couple_user.cpf,
              email: couple_user.email,
              addresses:addresses,
              sex: couple_user.sex,
              phone: user.phone,
              password: couple_user.password,
              is_foreign: user.is_foreign,
              privacy_policy: user.privacy_policy,
              invite: true,
            });

            yield put(
              ParticipantActions.createParticipantSuccess(responseCouple.data)
            );

            const created_couple_user = responseCouple.data;

            yield call(api.post, '/inscription_training', {
              entity_id: created_couple_user.id,
              event_id: data.event_id,
              assistant: false,
              order_id: response_order.data.id,
            });
          }

          if (couple_user.id !== null) {
            yield call(api.post, '/inscription_training', {
              entity_id: couple_user.id,
              event_id: data.event_id,
              assistant: false,
              order_id: response_order.data.id,
            });
          }

          toastr.success('Sucesso!', 'Solicitação criada com sucesso!');

          yield put(ParticipantActions.addParticipantSuccess());
          yield put(EventActions.eventSuccess(null));

          if (data.pix) {
            yield put(push(`/pedido/${response_order.data.id}/pix`))
          } else if (response_order.data.transaction.boleto_url) {
            window.open(response_order.data.transaction.boleto_url);
            yield put(
              push(`/evento/${data.event_id}/convite/${created_user.id}/confirmacao/sucesso`)
            );
          } else {
            yield put(
              push(`/evento/${data.event_id}/convite/${created_user.id}/confirmacao/sucesso`)
            );
          }
        }       
      }
    }

    // criacao pedido
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.createParticipantFailure());
    } else {
      const { data } = err.response;

      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.map(error => {
          toastr.error('Falha!', error.message);
        });
      }

      yield put(ParticipantActions.createParticipantFailure());
    }
  }
}

function* createParticipantSeminary(action) {
  try {
    const { data } = action.payload;
    const { user, couple_user, shipping_address, card, pix, event_id, entity_id } = data;      
    data.boleto_a_vista = true;
    data.order_details.amount = data.order_details.amount.toFixed(2);

    let addresses = [shipping_address]
  
    if (user.id === null) {
      const response_user = yield call(api.post, '/entity', {
        name: user.name,
        cpf: user.cpf,
        email: user.email,
        sex: user.sex,
        phone: user.phone,
        addresses:addresses,
        password: user.password,
        is_foreign: user.is_foreign,
        privacy_policy: user.privacy_policy,
        invite: true,
      });

      const created_user = response_user.data;

      yield put(ParticipantActions.createParticipantSuccess(created_user));

      if (created_user.id) {
        delete data.shipping_address.phone;
        data.user.id = created_user.id;       
        data.payment_info = paymentInfo(data);

        const response_order = yield call(api.post, '/order', data);

        if (response_order.data.id) {
          yield call(api.post, '/inscription_training', {
            entity_id: created_user.id,
            event_id: data.event_id,
            assistant: false,
            order_id: response_order.data.id,
          });
    
          if (couple_user.id === null && couple_user.cpf !== '') {
            const responseCouple = yield call(api.post, '/entity', {
              name: couple_user.name,
              cpf: couple_user.cpf,
              email: couple_user.email,
              sex: couple_user.sex,
              phone: user.phone,
              password: couple_user.password,
              addresses:addresses,
              foreign: user.foreign,
              invite: true,
            });
    
            yield put(ParticipantActions.createParticipantSuccess(responseCouple.data));
    
            const created_couple_user = responseCouple.data;
    
            yield call(api.post, '/inscription_training', {
              entity_id: created_couple_user.id,
              event_id: data.event_id,
              assistant: false,
              order_id: response_order.data.id,
            });
          }

          if (couple_user.id !== null) {
            yield call(api.post, '/inscription_training', {
              entity_id: couple_user.id,
              event_id: data.event_id,
              assistant: false,
              order_id: response_order.data.id,
            });
          }

          yield put(OrderActions.addOrderSuccess());      
          
          toastr.success('Sucesso!', 'Solicitação criada com sucesso!');  
          
          if (data.pix) {
            yield put(push(`/pedido/${response_order.data.id}/pix`))
          } else if (response_order.data.transaction.boleto_url) {
            window.open(response_order.data.transaction.boleto_url);
            yield put(
              push(`/evento/${event_id}/sucesso`)
            );
          } else {
            yield put(
              push(`/evento/${event_id}/sucesso`)
            );
          }     
      }
    }

    } else {
      const formattedPhone = data.shipping_address.phone
        .replace('+55', '')
        .replace('+', '')
        .replace(' ', '')
        .replace('(', '')
        .replace(')', '')
        .replace('-', '');

        const user_data ={
          phone: formattedPhone,
          privacy_policy: user.privacy_policy,
          name: user.name
        }
    
        if(user.id && user.changed)
        {
          user_data.email = user.email;
        }

        if(user.id && user.addresses_input)
        {
          user_data.addresses = [{
            "type":addresses[0].address_type,
            "other_type_name": addresses[0].address_other_type_name,
            "cep":addresses[0].cep,
            "uf":addresses[0].uf,
            "city":addresses[0].city,
            "neighborhood":addresses[0].neighborhood,
            "street":addresses[0].street,
            "street_number":addresses[0].street_number,
            "complement":addresses[0].complement,
            "receiver":addresses[0].receiver,
            "receiver_cpf":addresses[0].receiver_cpf,
            "country":"Brasil"
          }];
        }
    

      const response_user = yield call(api.put, `/entity/${user.id}`, user_data);

      const couple_data ={
        privacy_policy: user.privacy_policy,
        mailing: user.mailing,
        name: couple_user.name
      }
  
      if(couple_user.id && couple_user.addresses_input)
      {
        couple_data.addresses = [{
          "type":addresses[0].address_type,
          "other_type_name": addresses[0].address_other_type_name,
          "cep":addresses[0].cep,
          "uf":addresses[0].uf,
          "city":addresses[0].city,
          "neighborhood":addresses[0].neighborhood,
          "street":addresses[0].street,
          "street_number":addresses[0].street_number,
          "complement":addresses[0].complement,
          "receiver":addresses[0].receiver,
          "receiver_cpf":addresses[0].receiver_cpf,
          "country":"Brasil"
        }]
      }

      console.log("Dados do couple2"+JSON.stringify(couple_data))

      if(couple_user && couple_user.id !== null){
        const couple_response_user = yield call(api.put, `/entity/${couple_user.id}`, couple_data)
      }


      if (response_user.data.id) {
        delete data.shipping_address.phone;
        
        data.payment_info = paymentInfo(data);
         
        const response_order = yield call(api.post, '/order', data);

        if (response_order.data.id) {
          yield call(api.post, '/inscription_training', {
              entity_id: user.id,
              event_id: data.event_id,
              assistant: false,
              order_id: response_order.data.id,
          });

          if (couple_user.id === null && couple_user.cpf) {
              const responseCouple = yield call(api.post, '/entity', {
                  name: couple_user.name,
                  cpf: couple_user.cpf,
                  email: couple_user.email,
                  sex: couple_user.sex,
                  phone: null,
                  addresses:addresses,
                  password: couple_user.password,
                  foreign: user.foreign,
                  invite: true,
              });

              const created_couple_user = responseCouple.data;

              yield put(
                  ParticipantActions.createParticipantSuccess(responseCouple.data));

              yield call(api.post, '/inscription_training', {
                  entity_id: created_couple_user.id,
                  event_id: data.event_id,
                  assistant: false,
                  order_id: response_order.data.id,
              });
          }

          if (couple_user.id) {
              yield call(api.post, '/inscription_training', {
                  entity_id: couple_user.id,
                  event_id: data.event_id,
                  assistant: false,
                  order_id: response_order.data.id,
              });
          }


        yield put(OrderActions.addOrderSuccess());    
        
        toastr.success('Sucesso!', 'Solicitação criada com sucesso!');   
        
        if (data.pix) {
          yield put(push(`/pedido/${response_order.data.id}/pix`))
        } else if (response_order.data.transaction.boleto_url) {
          window.open(response_order.data.transaction.boleto_url);
          yield put(
            push(`/evento/${event_id}/sucesso`)
          );
        } else {
          yield put(
            push(`/evento/${event_id}/sucesso`)
          );
        }       
      }
    }
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.createParticipantFailure());
    } else {
      const { data } = err.response;

      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.map(error => {
          toastr.error('Falha!', error.message);
        });
      }

      yield put(ParticipantActions.createParticipantFailure());
    }
  }
}

function* addEvent(action) {
  try {
    const { data } = action.payload;
    const { organizator_id } = data;

    delete data.organizator_id;

    if (data.type) {
      const { schedules } = data;
      const { type } = data;

      delete data.type;
      delete data.schedules;

      const response = yield call(api.post, '/event', data);
      yield put(EventActions.addEventSuccess());

      yield call(api.post, '/event_organizator', {
        event_id: response.data.id,
        entity_id: organizator_id,
      });
      yield put(OrganizatorActions.addOrganizatorSuccess());

      schedules.forEach(schedule => {
        schedule.event_id = response.data.id;
        schedule.date = new Date(schedule.date).toISOString();
      });

      yield call(api.post, '/schedule', {
        schedules,
      });

      if (type === 'treinamento') {
        yield put(push('/eventos/treinamentos'));
        toastr.success('Sucesso!', 'O treinamento foi criado.');        
      } else if (type === 'atualizacao') {
        yield put(push('/eventos/atualizacoes'));
        toastr.success('Sucesso!', 'A atualização/imersão foi criada.');
      } else {
        yield put(push('/eventos/seminarios'));
        toastr.success('Sucesso!', 'O seminário foi criado.');
      }
    } else {
      const response = yield call(api.post, '/event', data);
      yield put(EventActions.addEventSuccess());

      yield call(api.post, '/event_organizator', {
        event_id: response.data.id,
        entity_id: organizator_id,
      });
      yield put(OrganizatorActions.addOrganizatorSuccess());
      yield put(push('/dashboard'));
      toastr.success('Sucesso!', 'O grupo foi criado.');
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EventActions.addEventFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao criar o evento.');
      yield put(EventActions.addEventFailure());
    }
  }
}

function* editEvent(action) {
  try {
    const { id, eventData } = action.payload;

    yield call(api.put, `/event/${id}`, eventData);

    yield put(EventActions.eventEditSuccess());

    toastr.confirm('Evento atualizado com sucesso', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    toastr.error('Falha!', 'Erro ao atualizar o evento.');
    yield put(EventActions.eventEditFailure());
  }
}

function* deleteEvent(action) {
  try {
    const { event_id } = action.payload;

    yield call(api.delete, `/event/${event_id}`);

    yield put(EventActions.deleteEventSuccess());
    window.location.reload();
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EventActions.deleteEventFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao remover o evento.');
      yield put(EventActions.deleteEventFailure());
    }
  }
}

function* addOrganizator(action) {
  try {
    const { event_id, entity_id } = action.payload;

    yield call(api.post, '/event_organizator', { event_id, entity_id });

    yield put(OrganizatorActions.addOrganizatorSuccess());

    toastr.confirm('Líder adicionado com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(OrganizatorActions.addOrganizatorFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(OrganizatorActions.addOrganizatorFailure());
    }
  }
}

function* deleteOrganizator(action) {
  try {
    const { event_id, entity_id } = action.payload;

    yield call(api.delete, `/event_organizator/${entity_id}/event/${event_id}`);

    yield put(OrganizatorActions.deleteOrganizatorSuccess());
    window.location.reload();
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(OrganizatorActions.deleteOrganizatorFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao remover o organizador.');
      yield put(OrganizatorActions.deleteOrganizatorFailure());
    }
  }
}

function* changeOrganizator(action) {
  try {
    const { organizator_id, event_id, entity_id, is_same } = action.payload;

    yield call(api.post, '/event_organizator', { event_id, entity_id });
    yield put(OrganizatorActions.addOrganizatorSuccess());

    yield call(
      api.delete,
      `/event_organizator/${organizator_id}/event/${event_id}`
    );
    yield put(OrganizatorActions.deleteOrganizatorSuccess());

    yield put(OrganizatorActions.changeOrganizatorSuccess());

    toastr.confirm('Líder alterado com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });

    if (is_same) {
      yield put(push('/eventos/grupos'));
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(OrganizatorActions.changeOrganizatorFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(OrganizatorActions.changeOrganizatorFailure());
    }
  }
}

function* searchOrganizator(action) {
  try {
    const { organizator_type, cpf_email, default_event_id } = action.payload;

    const response = yield call(
      api.get,
      `/event_organizator/${organizator_type}/${cpf_email}/${default_event_id}`
    );

    yield put(OrganizatorActions.searchOrganizatorSuccess(response.data));

    if (response.data.error) {
      yield put(OrganizatorActions.searchOrganizatorFailure(response.data));
      toastr.warning(response.data.error.title, response.data.error.message);
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(OrganizatorActions.searchOrganizatorFailure());
    } else {
      toastr.error(
        err.response.data.error.title,
        err.response.data.error.message
      );
      yield put(OrganizatorActions.searchOrganizatorFailure(err.response.data));
    }
  }
}

function* createParticipant(action) {
  try {
    const {
      name,
      cpf,
      email,
      phone,
      sex,
      password,
      is_foreign,
      event_id,
      assistant = false,
    } = action.payload;

    let addresses = [];

    try {
      const response = yield call(api.post, '/entity', {
        name,
        cpf,
        email,
        phone,
        addresses,
        sex,
        password,
        is_foreign,
      });
      if (response.data.id) {
        const entity_id = response.data.id;
        yield put(ParticipantActions.createParticipantSuccess());
        yield call(api.post, '/event_participant', {
          entity_id,
          event_id,
          assistant,
          order_id: null,
        });
        yield put(ParticipantActions.addParticipantSuccess());
        toastr.confirm(
          `${
            assistant ? 'Líder em treinamento' : 'Participante'
          } cadastrado e adicionado no curso com sucesso.`,
          {
            onOk: () => window.location.reload(),
            disableCancel: true,
          }
        );
      }
    } catch (e) {      
      //Verifica se o cpf ja existe e cadastra
      const { cpf, profile_id } = action.payload;
      const response = yield call(api.get, `/entity/cpf/${cpf}/${profile_id}`);
      if (response.data.id) {
        const entity_id = response.data.id;
        yield put(ParticipantActions.createParticipantSuccess());
        yield call(api.post, '/event_participant', {
          entity_id,
          event_id,
          assistant,
          order_id: null,
        });
        yield put(ParticipantActions.addParticipantSuccess());
        toastr.confirm(
          `${
            assistant ? 'Líder em treinamento' : 'Participante'
          } cadastrado e adicionado no curso com sucesso.`,
          {
            onOk: () => window.location.reload(),
            disableCancel: true,
          }
        );
      }else if (e.response.data && e.response.data[0]) {
        toastr.error('Falha no Cadastro', JSON.stringify(e.response.data[0].message));
      }
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.createParticipantFailure());
    } else {
      const { data } = err.response;
      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.map(error => {
          toastr.error('Falha!', error.message);
        });
      }

      yield put(ParticipantActions.createParticipantFailure());
    }
  }
}

function* setQuitterParticipant(action) {
  try {
    const { participant_id, is_quitter, assistant } = action.payload;

    yield call(api.put, `/event_participant/${participant_id}`, {
      is_quitter,
      assistant,
    });

    yield put(ParticipantActions.setQuitterParticipantSuccess());
    window.location.reload();
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.setQuitterParticipantFailure());
    } else {
      toastr.error(
        'Falha!',
        'Houve um erro ao tornar o participante desistente.'
      );
      yield put(ParticipantActions.setQuitterParticipantFailure());
    }
  }
}

function* editEventParticipant(action) {
  try {
    const {
      organizators_id,
      participants_id,
      event_id,
      reload = true,
    } = action.payload;

    yield call(api.put, `/participant_print_date`, {
      participants_id,
      event_id,
    });

    yield call(api.put, `/organizator_print_date`, {
      organizators_id,
      event_id,
    });

    yield put(ParticipantActions.editPrintDateSuccess());

    if (reload) {
      window.location.reload();
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.editPrintDateFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao alterar a data');
      yield put(ParticipantActions.editPrintDateFailure());
    }
  }
}

function* addParticipant(action) {
  try {
    const { entity_id, event_id, assistant } = action.payload;
    const response = yield call(api.post, '/event_participant', {
      entity_id,
      event_id,
      assistant,
      order_id: null,
    });

    if (response.data.error) {
      yield put(ParticipantActions.addParticipantFailure());
      toastr.warning(response.data.error.title, response.data.error.message);
    } else {
      yield put(ParticipantActions.addParticipantSuccess());

      if (assistant === true) {
        toastr.confirm('Líder em treinamento adicionado com sucesso.', {
          onOk: () => window.location.reload(),
          disableCancel: true,
        });
      } else {
        toastr.confirm('Participante adicionado com sucesso.', {
          onOk: () => window.location.reload(),
          disableCancel: true,
        });
      }
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.addParticipantFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao adicionar o participante.');
      yield put(ParticipantActions.addParticipantFailure());
    }
  }
}

function* editParticipant(action) {
  try {
    const { data } = action.payload;

    const { id } = data;
    delete data.id;

    yield call(api.put, `entity/${id}`, data);

    yield put(ParticipantActions.editParticipantSuccess());
    toastr.confirm('Participante alterado com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.editParticipantFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao editar o participante.');
      yield put(ParticipantActions.editParticipantFailure());
    }
  }
}

function* deleteParticipant(action) {
  try {
    const { entity_id, participant_id } = action.payload;

    yield call(api.delete, `/event_participant/${entity_id}/${participant_id}`);

    yield put(ParticipantActions.deleteParticipantSuccess());
    window.location.reload();
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.deleteParticipantFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao remover o participante.');
      yield put(ParticipantActions.deleteParticipantFailure());
    }
  }
}

function* searchInviteParticipant(action) {
  try {
    const { cpf_email, default_event_id, event_id } = action.payload;

    const response = yield call(
      api.get,
      `/searchParticipant/${cpf_email}/${default_event_id}/${event_id}`
    );

    yield put(ParticipantActions.searchParticipantInviteSuccess(response.data));

    if (response.data.error) {
      yield put(
        ParticipantActions.searchParticipantInviteFailure(response.data)
      );
      toastr.warning(response.data.error.title, response.data.error.message);
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.searchParticipantInviteFailure());
    } else {
      toastr.error(
        err.response.data.error.title,
        err.response.data.error.message
      );
      yield put(
        ParticipantActions.searchParticipantInviteFailure(err.response.data)
      );
    }
  }
}

function* searchParticipant(action) {
  try {
    const { cpf_email, default_event_id } = action.payload;

    const response = yield call(
      api.get,
      `/event_participant/${cpf_email}/${default_event_id}`
    );

    yield put(ParticipantActions.searchParticipantSuccess(response.data));

    if (response.data.error) {
      yield put(ParticipantActions.searchParticipantFailure(response.data));
      toastr.warning(response.data.error.title, response.data.error.message);
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.searchParticipantFailure());
    } else {
      toastr.error(
        err.response.data.error.title,
        err.response.data.error.message
      );
      yield put(ParticipantActions.searchParticipantFailure(err.response.data));
    }
  }
}

function* searchParticipantByEmail(action) {
  try {
    const { email, current_email } = action.payload;

    const response = yield call(
      api.get,
      `/entity/email/${email}/${current_email}`
    );

    if (!response.data) {
      toastr.warning('Aviso!', 'Esse email já existe');
      yield put(ParticipantActions.searchParticipantByEmailFailure(false));
    }

    yield put(
      ParticipantActions.searchParticipantByEmailSuccess(response.data)
    );
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.searchParticipantByEmailFailure(false));
    } else {
      yield put(ParticipantActions.searchParticipantByEmailFailure(false));
    }
  }
}

function* changeParticipantToLeader(action) {
  try {
    const { participant_id, entity_id, event_id } = action.payload;

    yield call(api.delete, `/event_participant/${entity_id}/${participant_id}`);

    yield put(ParticipantActions.deleteParticipantSuccess());

    yield call(api.post, '/event_organizator', { event_id, entity_id });

    yield put(OrganizatorActions.addOrganizatorSuccess());

    window.location.reload();
    // toastr.confirm('Líder adicionado com sucesso.', {
    //   onOk: () => window.location.reload(),
    //   disableCancel: true,
    // });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.changeParticipantLeaderFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao alterar o participante.');
      yield put(ParticipantActions.changeParticipantLeaderFailure());
    }
  }
}

function* searchChurch(action) {
  try {
    const { church_uf, church_city, church_name, church_cnpj } = action.payload;

    const response = yield call(
      api.get,
      `/churchs/${church_uf}/${church_city}/${church_name}/${church_cnpj}`
    );

    if (response.data.error) {
      toastr.error(response.data.error.title, response.data.error.message);
    }

    yield put(SearchChurchActions.searchChurchSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(SearchChurchActions.searchChurchFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao buscar uma organização.');
      yield put(SearchChurchActions.searchChurchFailure());
    }
  }
}

function* shippingOptions(action) {
  try {
    const { cep, products } = action.payload;

    const headers = {
      'Content-Type': 'application/json',
      'api-key':
        '1273704cf48278e8e198c13059267033a16a636c878dc8f6b21f069d9e3aa97d',
    };

    const response = yield call(
      axios.post,
      'https://api.intelipost.com.br/api/v1/quote_by_product',
      {
        origin_zip_code: '17581022',
        destination_zip_code: cep,
        products,
      },
      {
        headers,
      }
    );

    if (response.data.status === 'ERROR') {
      yield put(ShippingActions.shippingOptionsFailure());
      toastr.warning('Aviso!', 'Erro na cotação');
    } else {
      yield put(
        ShippingActions.shippingOptionsSuccess(
          response.data.content.delivery_options
        )
      );
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ShippingActions.shippingOptionsFailure());
    } else {
      // eslint-disable-next-line array-callback-return
      err.response.data.messages.map(message => {
        toastr.error('Falha na cotação!', message.text);
      });
      yield put(ShippingActions.shippingOptionsFailure());
    }
  }
}

function* cepCheck(action) {
  try {
    const { cep, index } = action.payload;

    const response = yield call(
      axios.get,
      `https://viacep.com.br/ws/${cep}/json/`
    );

    response.data.index = index;

    if (response.data.erro) {  
      yield put(CepActions.cepFailure());   
      toastr.warning('Aviso!', 'CEP não encontrado. Necessário ajustar no cadastro!');
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');      
    } else {
      toastr.error('Falha!', 'CEP inválido.');
    }
  }
}

function* cep(action) {
  try {
    const { cep, index } = action.payload;

    const response = yield call(
      axios.get,
      `https://viacep.com.br/ws/${cep}/json/`
    );

    response.data.index = index;

    if (response.data.erro) {
      yield put(CepActions.cepFailure());
      toastr.warning('Aviso!', 'CEP não encontrado.');
    } else {
      yield put(CepActions.cepSuccess(response.data));
      toastr.success('Sucesso!', 'CEP encontrado.');
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(CepActions.cepFailure());
    } else {
      toastr.error('Falha!', 'CEP inválido.');
      yield put(CepActions.cepFailure());
    }
  }
}

function* checkoutLogin(action) {
  try {
    const { email_cpf_cnpj, password, event_id, invite_id } = action.payload;

    const response = yield call(api.post, '/sessions', {
      email_cpf_cnpj,
      password,
    });

    const { user } = response.data;

    if (!response.data.error) {
      yield put(CheckoutActions.checkoutLoginSuccess(response.data));

      localStorage.setItem('@dashboard/checkout_token', response.data.token);
      localStorage.setItem('@dashboard/checkout_user', response.data.user.id);

      if (
        !!user.cep &&
        !!user.uf &&
        !!user.city &&
        !!user.street &&
        !!user.street_number &&
        !!user.neighborhood
      ) {
        if (invite_id) {
          yield put(
            push(`/evento/${event_id}/checkout/pagamento/convite/${invite_id}`)
          );
        } else {
          yield put(push(`/evento/${event_id}/checkout/pagamento`));
        }
      } else if (invite_id) {
        yield put(
          push(`/evento/${event_id}/checkout/endereco/convite/${invite_id}`)
        );
      } else {
        yield put(push(`/evento/${event_id}/checkout/endereco`));
      }
    } else {
      yield put(CheckoutActions.checkoutLoginFailure());

      yield put(push('/senha-expirada'));
      toastr.warning(response.data.error.title, response.data.error.message);
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(CheckoutActions.checkoutLoginFailure());
    } else {
      toastr.error(
        err.response.data.error.title,
        err.response.data.error.message
      );
      yield put(CheckoutActions.checkoutLoginFailure());
    }
  }
}

function* checkoutSignup(action) {
  try {
    const { firstname, lastname, email, cpf_cnpj, password } = action.payload;

    yield call(api.post, '/users', {
      firstname,
      lastname,
      email,
      cpf_cnpj,
      password,
    });

    yield put(CheckoutActions.checkoutSignupSuccess());

    yield put(push('/'));
    toastr.success('Sucesso!', 'Cadastro realizado com sucesso.');
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(CheckoutActions.checkoutSignupFailure());
    } else if (
      err.response.data &&
      err.response.data[0] &&
      err.response.data[0].message
    ) {
      toastr.error(
        'Falha!',
        capitalizeFirstLetter(err.response.data[0].message)
      );
      yield put(SignupActions.signupFailure());
    } else {
      toastr.error('Falha!', 'Tente cadastrar novamente.');
      yield put(SignupActions.signupFailure());
    }
  }
}

// function* checkoutPayment(action) {}

function* lessonReport(action) {
  try {
    const { id } = action.payload;

    const response = yield call(api.get, `/lesson_report/${id}`);

    yield put(LessonReportActions.lessonReportSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(LessonReportActions.lessonReportFailure());
    } else {
      toastr.error('Falha!', 'Tente novamente');
      yield put(LessonReportActions.lessonReportFailure());
    }
  }
}

function* lessonReportEdit(action) {
  try {
    const { eventId, data } = action.payload;

    const response = yield call(
      api.put,
      `/lesson_report/${data.lesson_report_id}`,
      data
    );

    yield put(LessonReportActions.editLessonReportSuccess(response.data));

    toastr.confirm('Relatório confirmado.', {
      onOk: yield put(push(`/eventos/grupo/${eventId}/editar`)),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(LessonReportActions.editLessonReportFailure());
    } else {
      toastr.error('Falha!', 'Tente novamente');
      yield put(LessonReportActions.editLessonReportFailure());
    }
  }
}

function* siteEvent(action) {
  try {
    const { id } = action.payload;
    const response = yield call(api.get, `/site_event/${id}`);
    yield put(SiteEventActions.siteEventSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(SiteEventActions.siteEventFailure());
    } else {
      toastr.error('Falha!', 'Tente novamente');
      yield put(SiteEventActions.siteEventFailure());
    }
  }
}

function* organizatorEvent(action) {
  try {
    let response;
    const { data } = action.payload;
    const user_type = localStorage.getItem('@dashboard/user_type');

    if (user_type === 'entity') {
      response = yield call(api.post, '/organizator_events', data);
    } else {
      response = yield call(api.post, '/default_events', data);
    }

    yield put(DefaultEventActions.organizatorEventSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(DefaultEventActions.organizatorEventFailure());
    } else {
      toastr.error('Falha!', 'Tente novamente');
      yield put(DefaultEventActions.organizatorEventFailure());
    }
  }
}

function* allDefaultEvent() {
  try {
    const response = yield call(api.get, '/default_event');

    yield put(DefaultEventActions.allDefaultEventSuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(DefaultEventActions.allDefaultEventFailure());
  }
}

function* defaultEventSchedules(action) {
  try {
    const { id } = action.payload;

    const response = yield call(api.get, `/default_event_schedules/${id}`);

    yield put(
      DefaultEventScheduleActions.allDefaultEventScheduleSuccess(response.data)
    );
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(DefaultEventScheduleActions.allDefaultEventScheduleFailure());
  }
}

function* order(action) {
  try {
    const { id } = action.payload;

    const response = yield call(api.get, `/order/${id}`);

    yield put(OrderActions.orderSuccess(response.data));
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(OrderActions.orderFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao carregar os dados do pedido.');
      yield put(OrderActions.orderFailure());
    }
  }
}

function* addEntity(action) {
  try {
    const { data } = action.payload;
    const { user, address} = data;    

    user.addresses = [address];

    const response = yield call(api.post, '/entity', user);
    yield put(EntityActions.addEntitySuccess());       

    yield put(push(`/admin/consulta/entidades/`+ response.data.id));
    toastr.success('Sucesso!', 'Entidade criada com sucesso.');        
    
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EntityActions.addEntityFailure());
    } else if (err.response) {
      if (err.response.data.title) {
        toastr.error(err.response.data.title, err.response.data.message);
      }

      if (err.response.data[0].field) {
        toastr.error(err.response.data[0].field, err.response.data[0].message);
      }
      
      yield put(EntityActions.addEntityFailure());
    } else {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(EntityActions.addEntityFailure());
    }
  }
}

function* addOrganization(action) {
  try {
    console.log("foi longe");
    const { data } = action.payload;
    const { company, address} = data;    

    company.addresses = [address];

    const response = yield call(api.post, '/organization', company);
    yield put(OrganizationActions.addOrganizationSuccess());       

    yield put(push(`/admin/consulta/entidades/pj/`+ response.data.id));
    toastr.success('Sucesso!', 'Entidade criada com sucesso.');        
    
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(OrganizationActions.addOrganizationFailure());
    } else if (err.response) {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(OrganizationActions.addOrganizationFailure());
    } else {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(OrganizationActions.addOrganizationFailure());
    }
  }
}

function* addOrder(action) {
  try {
    const { data } = action.payload;
    const { user, products, shipping_address, card} = data;

    delete data.user.participants;
    delete data.user.organizators;

    data.order_details.amount = data.order_details.amount.toFixed(2);
    data.invite = true;
   
    if(data.boleto_a_vista == null)
      data.boleto_a_vista = true;


    let user_type = localStorage.getItem('@dashboard/user_type');
    let user_id   = localStorage.getItem('@dashboard/user');
    const formattedPhone = data.shipping_address.phone
      .replace('+55', '')
      .replace('+', '')
      .replace(' ', '')
      .replace('(', '')
      .replace(')', '')
      .replace('-', '');
 
    if(user.id != user_id){
      user_id = user.id ;
      user_type = user.cpf ? 'entity' : 'organization';
    }
    const response_user = yield call(
      api.put,
      `${
        user_type === 'entity'
          ? `/entity/${user_id}`
          : `/organization/${user_id}`
      }`,
      { phone: formattedPhone }
    );       

    if (response_user.data.id) {
      delete data.shipping_address.phone;  
      data.payment_info = paymentInfo(data);      
      const response = yield call(api.post, '/order', data);
      yield put(OrderActions.addOrderSuccess()); 
      console.log('Dispositivo Mobile? '+ isMobile);   

      toastr.success('Sucesso!', 'Solicitação criada com sucesso!');     

      if(isMobile === true && data.pix){
        yield put(push(`/pedido/${response.data.id}/pix`));  
      } else if (data.pix) {
        yield put(push(`/pedido/${response.data.id}/pix`))
      } else if (response.data.transaction.boleto_url) {
        window.open(response.data.transaction.boleto_url);
        yield put(push(`/pedido/${response.data.id}/visualizar`));  
      }
      else if(!isMobile || !data.pix){
        yield put(push(`/pedido/${response.data.id}/visualizar`));  
      }

        
    }
  } catch (err) {

    console.log(err);

    if (err.message === 'Network Error') {
      toastr.error('Falha na Criação do Pedido!', 'Tente acessar novamente mais tarde para realizar novo pedido.');
      yield put(OrderActions.addOrderFailure());
    } else if (err.response) {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(OrderActions.addOrderFailure());
    } else {
      toastr.error('Erro Desconhecido!', 'Tente acessar novamente mais tarde para realizar novo pedido.');
      yield put(OrderActions.addOrderFailure());
    }
  }
}

// function* deleteOrder(action) {}
function* allNews() {
  try {
    const response = yield call(api.get, '/news');
    yield put(NewsActions.allNewsSuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(NewsActions.allNewsFailure());
  }
}

function* allMinistery() {
  try {
    const response = yield call(api.get, '/ministery');

    yield put(MinisteryActions.allMinisterySuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(MinisteryActions.allMinisteryFailure());
  }
}

function* ministery(action) {
  try {
    const { id } = action.payload;

    const response = yield call(api.get, `/ministery/${id}`);

    yield put(MinisteryActions.ministerySuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(MinisteryActions.ministeryFailure());
  }
}

function* editMinistery(action) {
  try {
    const { id, editData } = action.payload;

    const { name } = editData;
    const { email } = editData;
    const { phone } = editData;

    yield call(api.put, `/ministery/${id}`, {
      name,
      email,
      phone,
    });

    yield put(MinisteryActions.editMinisterySuccess());
    toastr.confirm('Ministério alterado com sucesso.', {
      onOk: yield put(push('/admin/configuracao/ministerios')),
      disableCancel: true,
    });
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(MinisteryActions.editMinisteryFailure());
  }
}
function* allCertificate() {
  try {
    const response = yield call(api.get, '/layout_certificates');

    yield put(CertificateActions.allCertificateSuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(CertificateActions.allCertificateFailure());
  }
}


function* allLesson() {
  try {
    const response = yield call(api.get, '/lesson');

    yield put(LessonActions.allLessonSuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(LessonActions.allLessonFailure());
  }
}

function* lesson(action) {
  try {
    const { id } = action.payload;

    const response = yield call(api.get, `/lesson/${id}`);

    yield put(LessonActions.lessonSuccess(response.data));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(LessonActions.lessonFailure());
  }
}

function* editLesson(action) {
  try {
    const { id, editData } = action.payload;

    const { title } = editData;
    const { description } = editData;
    const { video_id } = editData;
    const { img_url } = editData;

    yield call(api.put, `/lesson/${id}`, {
      title,
      description,
      video_id,
      img_url,
    });

    yield put(LessonActions.editLessonSuccess());
    toastr.confirm('Lição alterada com sucesso.', {
      onOk: yield put(push('/admin/configuracao/licoes')),
      disableCancel: true,
    });
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(LessonActions.editLessonFailure());
  }
}

function* addLesson(action) {
  try {
    const { data } = action.payload;

    yield call(api.post, '/lesson', {
      default_event_id: data.default_event_id,
      title: data.title,
      description: data.description,
      video_id: data.video_id,
      img_url: data.img_url,
    });

    yield put(LessonActions.addLessonSuccess());
    toastr.confirm('Lição alterada com sucesso.', {
      onOk: yield put(push('/admin/configuracao/licoes')),
      disableCancel: true,
    });
  } catch (err) {
    toastr.error('Erro!', 'Ocorreu um erro');
    yield put(LessonActions.addLessonFailure());
  }
}

function* deleteLesson(action) {
  try {
    const { lesson_id } = action.payload;

    yield call(api.delete, `/lesson/${lesson_id}`);

    yield put(LessonActions.deleteLessonSuccess());
    window.location.reload();
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(LessonActions.deleteLessonFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao remover a lição.');
      yield put(LessonActions.deleteLessonFailure());
    }
  }
}

function* editParticipantHierarchy(action) {
  try {
    const {
      data,
      eventId,
      participantsId,
      assistantsId,
      hierarchyName,
      participantWillBecome,
      assistantWillBecome,
      eventType,
    } = action.payload;

    const response = yield call(
      api.put,
      `/lesson_report/${data.lesson_report_id}`,
      data
    );

    yield put(LessonReportActions.editLessonReportSuccess(response.data));

    if (hierarchyName === 'mu_hierarchy_id') {
      yield call(api.put, `entity_hierarchy/${eventId}`, {
        participantsId: [],
        assistantsId,
        hierarchyName: 'cmn_hierarchy_id',
        participantWillBecome,
        assistantWillBecome,
      });
    }

    yield call(api.put, `entity_hierarchy/${eventId}`, {
      participantsId,
      assistantsId,
      hierarchyName,
      participantWillBecome,
      assistantWillBecome,
    });

    yield put(ParticipantActions.editParticipantHierarchySuccess());

    if (eventType === 'grupo') {
      toastr.confirm('Relatório confirmado.', {
        onOk: yield put(push(`/eventos/grupo/${eventId}/editar`)),
        disableCancel: true,
      });
    }
    if (eventType === 'treinamento' || eventType === 'seminario') {
      toastr.confirm('Evento finalizado.', {
        onOk: window.location.reload(),
        disableCancel: true,
      });
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(ParticipantActions.editParticipantHierarchyFailure());
    } else {
      toastr.error('Falha!', 'Houve um erro ao editar o participante.');
      yield put(ParticipantActions.editParticipantHierarchyFailure());
    }
  }
}

function* shippingTag(action) {
  try {
    const { data } = action.payload;

    const response = yield call(api.post, '/shipping_tag', data);

    yield put(ShippingTagActions.shippingTagSuccess(response.data));
  } catch (err) {
    yield put(ShippingTagActions.shippingTagFailure());
  }
}

function* relationship(action) {
  try {
    const { entity_id } = action.payload;

    const response = yield call(api.get, `/relationship/entity/${entity_id}`);

    yield put(RelationshipActions.relationshipSuccess(response.data));
  } catch (err) {
    yield put(RelationshipActions.relationshipFailure());
  }
}

function* addRelationship(action) {
  try {
    const {
      entity_id,
      relationship_id,
      relationship_type,
      relationship_sex,
    } = action.payload;

    yield call(api.post, '/relationship', {
      entity_id,
      relationship_id,
      relationship_type,
      relationship_sex,
    });

    toastr.confirm('Familiar adicionado com sucesso!', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });

    yield put(RelationshipActions.addRelationshipSuccess());
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(RelationshipActions.addRelationshipFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(RelationshipActions.addRelationshipFailure());
    }
  }
}

function* editRelationship(action) {
  try {
    const { id, editData } = action.payload;

    yield call(api.put, `/relationship/${id}`, { relationship_type: editData });

    yield put(RelationshipActions.editRelationshipSuccess());

    toastr.confirm('Familiar atualizado com sucesso!', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(RelationshipActions.editRelationshipFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(RelationshipActions.editRelationshipFailure());
    }
  }
}

function* deleteRelationship(action) {
  try {
    const { relationship_id } = action.payload;

    yield call(api.delete, `/relationship/${relationship_id}`);

    yield put(RelationshipActions.deleteRelationshipSuccess());

    toastr.confirm('Familiar removido com sucesso!', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(RelationshipActions.deleteRelationshipFailure());
    } else {
      toastr.error(err.response.data.title, err.response.data.message);
      yield put(RelationshipActions.deleteRelationshipFailure());
    }
  }
}

function* createRelationship(action) {
  try {
    const {
      entity_id,
      name,
      cpf,
      email,
      sex,
      password,
      is_foreign,
      relationship_type,
    } = action.payload;

    const response = yield call(api.post, '/entity', {
      name,
      cpf,
      email,
      sex,
      password,
      is_foreign,
    });

    // const response = yield call(api.post, '/user', {
    //   name,
    //   cpf_cnpj,
    //   email,
    //   sex,
    //   password,
    // });

    if (response.data.id) {
      const relationship_id = response.data.id;
      yield put(RelationshipActions.createRelationshipSuccess());

      yield call(api.post, '/relationship', {
        entity_id,
        relationship_id,
        relationship_type,
      });

      yield put(RelationshipActions.addRelationshipSuccess());

      toastr.confirm('Familiar adicionado e cadastrado com sucesso.', {
        onOk: () => window.location.reload(),
        disableCancel: true,
      });
    }
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente acessar novamente mais tarde.');
      yield put(RelationshipActions.createRelationshipFailure());
    } else {
      const { data } = err.response;

      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.map(error => {
          toastr.error('Falha!', error.message);
        });
      }

      yield put(RelationshipActions.createRelationshipFailure());
    }
  }
}

// CUSTOMIZAÇÕES DO TEMA
function* customizerBgImage(action) {
  try {
    const { img } = action.payload;

    yield put(CustomizerActions.sidebarImageSuccess(img));
  } catch (err) {
    yield put(CustomizerActions.customizerFailure());
  }
}

function* organization(action) {
  try {
    const { id } = action.payload;

    const response = yield call(api.get, `/organization/${id}`);

    yield put(OrganizationActions.organizationSuccess(response.data));
  } catch (err) {
    if(err.response && err.response.data){
      toastr.error(
        err.response.data.error.title,
        err.response.data.error.message
      );
    }
    yield put(OrganizationActions.organizationFailure());
  }
}

function* editOrganization(action) {
  try {
    const { data } = action.payload;
    const { organization_id: id } = data;
    delete data.organization_id;

    const user_type = localStorage.getItem('@dashboard/user_type');
    const user_id = localStorage.getItem('@dashboard/user');

    if (id) {
      yield call(api.put, `/organization/${id}`, data);
    } else {
      yield call(
        api.put,
        `${
          user_type === 'entity'
            ? `/entity/${user_id}`
            : `/organization/${user_id}`
        }`,
        data
      );
    }

    // if (id) {
    //   yield call(api.put, `/user/pj/${id}`, data);
    // } else {
    //   yield call(
    //     api.put,
    //     `${
    //       user_type === 'entity' ? `/user/pf/${user_id}` : `/user/pj/${user_id}`
    //     }`,
    //     data
    //   );
    // }

    yield put(OrganizationActions.editOrganizationSuccess());
    toastr.confirm('Perfil atualizado com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    if (err.message === 'Network Error') {
      toastr.error('Falha!', 'Tente novamente mais tarde.');
      yield put(OrganizationActions.editOrganizationFailure());
    } else {
      const { data } = err.response;

      if (data && data.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.map(error => {
          toastr.error('Falha!', error.message);
        });
      }

      yield put(OrganizationActions.editOrganizationFailure());
    }
  }
}

function* offerFile(action) {
  try {
    const { file, name, event_id, date, amount } = action.payload;

    const id = localStorage.getItem('@dashboard/user');
    const data = new FormData();

    const dto_object = new Blob([JSON.stringify(
      {event_id:event_id, payer_id:id, date:date, amount:amount}
    )], {
    type: 'application/json'
    })

    data.append('file', file, name)
    data.append('info', dto_object , 'offerInfo');


    if (id) {
      yield call(api.post, `/offer`, data);
    } 

    yield put(OfferActions.fileSuccess());

    toastr.confirm('Pagamento enviado com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    console.log(JSON.stringify(err))
    toastr.error(
      err.response.data.error.title,
      err.response.data.error.message
    );
    yield put(OfferActions.fileFailure());
  }
}

function* avatar(action) {
  try {
    const { file, name, entity_id: id, user_type } = action.payload;

    const user_id = localStorage.getItem('@dashboard/user');
    const data = new FormData();

    data.append('file', file, name);

    if (id) {
      yield call(api.post, `/files/${id}/${user_type}`, data);
    } else {
      yield call(api.post, `/files/${user_id}/${user_type}`, data);
    }

    yield put(AvatarActions.avatarSuccess());

    toastr.confirm('Foto atualizada com sucesso.', {
      onOk: () => window.location.reload(),
      disableCancel: true,
    });
  } catch (err) {
    toastr.error(
      err.response.data.error.title,
      err.response.data.error.message
    );
    yield put(AvatarActions.avatarFailure());
  }
}

function* customizerBgImageUrl(action) {
  try {
    const { imgurl } = action.payload;

    yield put(CustomizerActions.sidebarImageUrlSuccess(imgurl));
  } catch (err) {
    yield put(CustomizerActions.customizerFailure());
  }
}

function* customizerBgColor(action) {
  try {
    const { color } = action.payload;

    yield put(CustomizerActions.sidebarBgColorSuccess(color));
  } catch (err) {
    toastr.error('Falha!', 'Tente novamente');
    yield put(CustomizerActions.customizerFailure());
  }
}

function* customizerSidebarCollapsed(action) {
  try {
    const { collapsed } = action.payload;

    yield put(CustomizerActions.sidebarCollapsedSuccess(collapsed));
  } catch (err) {
    yield put(CustomizerActions.customizerFailure());
  }
}

function* customizerSidebarSize(action) {
  try {
    const { size } = action.payload;

    yield put(CustomizerActions.sidebarSizeSuccess(size));
  } catch (err) {
    yield put(CustomizerActions.customizerFailure());
  }
}

function* customizerLayout(action) {
  try {
    const { layout } = action.payload;

    yield put(CustomizerActions.changeLayoutSuccess(layout));
  } catch (err) {
    yield put(CustomizerActions.customizerFailure());
  }
}

function* logs(action) {
  try {
    const { models, requesting_id } = action.payload;

    const response = yield call(api.post, '/logs', {
      models,
      requesting_id,
    });

    yield put(LogActions.logsSuccess(response.data));
  } catch (err) {
    toastr.error(
      err.response.data.error.title,
      err.response.data.error.message
    );
    yield put(LogActions.logsFailure());
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(SignupTypes.REQUEST, signup),
    takeLatest(LoginTypes.REQUEST, login),
    takeLatest(ResetPasswordTypes.REQUEST, resetPassword),
    takeLatest(ResetPasswordTypes.CONFIRM_REQUEST, confirmResetPassword),
    takeLatest(ProfileTypes.PASSWORD_REQUEST, changePassword),
    takeLatest(LoginTypes.LOGOUT_REQUEST, logout),
    takeLatest(LoginTypes.HEALTHCHECK_REQUEST, healthcheck),
    takeLatest(ProfileTypes.REQUEST, profile),
    takeLatest(ExpiredTitlesTypes.REQUEST, expiredTitles),
    takeLatest(AddressTypes.REQUEST, address),
    takeLatest(AddressTypes.DELETE_REQUEST, deleteAddress),
    takeLatest(BankTypes.REQUEST, bank),
    takeLatest(BankAccountTypes.REQUEST, bankAccount),
    takeLatest(BankAccountTypes.DELETE_REQUEST, deleteBankAccount),
    takeLatest(ScheduleTypes.REQUEST, scheduleEvents),
    takeLatest(ScheduleTypes.DELETE_REQUEST, deleteSchedule),
    takeLatest(ProfileTypes.EDIT_REQUEST, editProfile),
    takeLatest(ProfileTypes.PRIVACY_REQUEST, acceptPrivacy),
    takeLatest(EntityTypes.REQUEST, consultEntity),
    takeLatest(EntityTypes.CPF_REQUEST, consultEntityCpf),
    takeLatest(EntityTypes.POLICY_REQUEST, checkPolicy),
    takeLatest(EntityTypes.ALL_CONSULT_REQUEST, allConsultEntities),
    takeLatest(EntityTypes.ADD_REQUEST, addEntity),
    takeLatest(OrganizationTypes.ADD_REQUEST, addOrganization),
    takeLatest(EntityTypes.SEARCH_REQUEST, entities),
    takeLatest(ExportExcelTypes.EVENT_REQUEST, exportExcel),
    takeLatest(ExportExcelTypes.ENTITY_REQUEST, entityExportExcel),
    takeLatest(ExportExcelTypes.ORGANIZATION_REQUEST, organizationExportExcel),

    takeLatest(ChurchTypes.REQUEST, churchs),

    takeLatest(EventTypes.REQUEST, event),
    takeLatest(EventTypes.ALL_REQUEST, allEvents),
    takeLatest(EventTypes.ADD_REQUEST, addEvent),
    takeLatest(EventTypes.EDIT_REQUEST, editEvent),
    takeLatest(EventTypes.DELETE_REQUEST, deleteEvent),
    takeLatest(EventTypes.ALL_CONSULT_REQUEST, allConsultEvent),
    takeLatest(EventTypes.ALL_CONSULT_PRINT_REQUEST, allEventForAdminPrint),

    takeLatest(OrderTypes.ALL_CONSULT_REQUEST, allConsultOrders),
    takeLatest(OrderTypes.CHECK_PAYMENT_REQUEST, checkPayment),
    takeLatest(OrderTypes.LOAD_PAYMENT_REQUEST, loadPayment),

    takeLatest(InviteTypes.ADD_REQUEST, addInvite),
    takeLatest(InviteTypes.CONFIRM_REQUEST, confirmInvite),
    takeLatest(InviteTypes.DELETE_REQUEST, deleteInvite),
    takeLatest(InviteTypes.CREATE_BY_INVITE_REQUEST, createByInviteParticipant),
    takeLatest(
      InviteTypes.CONFIRM_INVITE_ORDER_REQUEST,
      confirmParticipantInviteOrder
    ),
    takeLatest(
      InviteTypes.CREATE_BY_INVITE_ORDER_REQUEST,
      createByInviteOrderParticipant
    ),
    takeLatest(
      InviteTypes.CREATE_PARTICIPANT_TRAINING_REQUEST,
      createParticipantSeminary
    ),

    takeLatest(OrganizatorTypes.ADD_REQUEST, addOrganizator),
    takeLatest(OrganizatorTypes.DELETE_REQUEST, deleteOrganizator),
    takeLatest(OrganizatorTypes.CHANGE_REQUEST, changeOrganizator),
    takeLatest(OrganizatorTypes.SEARCH_REQUEST, searchOrganizator),

    takeLatest(ParticipantTypes.ADD_REQUEST, addParticipant),
    takeLatest(ParticipantTypes.DELETE_REQUEST, deleteParticipant),
    takeLatest(ParticipantTypes.SEARCH_INVITE_REQUEST, searchInviteParticipant),
    takeLatest(ParticipantTypes.SEARCH_REQUEST, searchParticipant),
    takeLatest(ParticipantTypes.SEARCH_BY_EMAIL_REQUEST, searchParticipantByEmail),
    takeLatest(ParticipantTypes.CREATE_REQUEST , createParticipant),
    takeLatest(ParticipantTypes.EDIT_REQUEST, editParticipant),
    takeLatest(ParticipantTypes.SET_QUITTER_REQUEST, setQuitterParticipant),
    takeLatest(ParticipantTypes.EDIT_HIERARCHY_REQUEST, editParticipantHierarchy),
    takeLatest(ParticipantTypes.CHANGE_PARTICIPANT_LEADER_REQUEST, changeParticipantToLeader),
    takeLatest(ParticipantTypes.EDIT_PRINT_DATE_REQUEST, editEventParticipant),
    takeLatest(ParticipantTypes.UPDATEPHONE_REQUEST, updatePhoneParticipant),

    takeLatest(OrderTypes.REQUEST, order),
    // takeLatest(OrderTypes.ALL_REQUEST, allOrders),
    takeLatest(OrderTypes.ADD_REQUEST, addOrder),
    // takeLatest(OrderTypes.DELETE_REQUEST, deleteOrder),
    takeLatest(NewsTypes.ALL_NEWS_REQUEST, allNews),
    takeLatest(MinisteryTypes.ALL_REQUEST, allMinistery),
    takeLatest(MinisteryTypes.REQUEST, ministery),
    takeLatest(MinisteryTypes.EDIT_REQUEST, editMinistery),

    takeLatest(CertificateTypes.ALL_REQUEST, allCertificate),
    // takeLatest(CertificateTypes.REQUEST, certificate),
    // takeLatest(CertificateTypes.EDIT_REQUEST, editCertificate),

    takeLatest(LessonReportTypes.REQUEST, lessonReport),
    takeLatest(LessonReportTypes.EDIT_REQUEST, lessonReportEdit),

    takeLatest(LessonTypes.ALL_REQUEST, allLesson),
    takeLatest(LessonTypes.REQUEST, lesson),
    takeLatest(LessonTypes.EDIT_REQUEST, editLesson),
    takeLatest(LessonTypes.ADD_REQUEST, addLesson),
    takeLatest(LessonTypes.DELETE_REQUEST, deleteLesson),

    takeLatest(DefaultEventTypes.ORGANIZATOR_EVENT_REQUEST, organizatorEvent),
    takeLatest(DefaultEventTypes.ALL_REQUEST, allDefaultEvent),

    takeLatest(DefaultEventScheduleTypes.ALL_REQUEST, defaultEventSchedules),

    takeLatest(ShippingTypes.SHIPPING_REQUEST, shippingOptions),

    takeLatest(CepTypes.REQUEST, cep),
    takeLatest(CepTypes.CHECK, cepCheck),

    takeLatest(OrganizationTypes.REQUEST, organization),
    takeLatest(OrganizationTypes.EDIT_REQUEST, editOrganization),

    takeLatest(ShippingTagTypes.REQUEST, shippingTag),

    takeLatest(RelationshipTypes.REQUEST, relationship),
    takeLatest(RelationshipTypes.EDIT_REQUEST, editRelationship),
    takeLatest(RelationshipTypes.DELETE_REQUEST, deleteRelationship),
    takeLatest(RelationshipTypes.ADD_REQUEST, addRelationship),
    takeLatest(RelationshipTypes.CREATE_REQUEST, createRelationship),

    // takeLatest(GroupEditTypes.REQUEST, groupEdit),

    takeLatest(CustomizerTypes.BG_IMAGE_REQUEST, customizerBgImage),
    takeLatest(CustomizerTypes.BG_IMAGE_URL_REQUEST, customizerBgImageUrl),
    takeLatest(CustomizerTypes.BG_COLOR_REQUEST, customizerBgColor),
    takeLatest(
      CustomizerTypes.SIDEBAR_COLLAPSED_REQUEST,
      customizerSidebarCollapsed
    ),
    takeLatest(CustomizerTypes.SIDEBAR_SIZE_REQUEST, customizerSidebarSize),
    takeLatest(CustomizerTypes.LAYOUT_REQUEST, customizerLayout),
    takeLatest(SearchChurchTypes.REQUEST, searchChurch),
    takeLatest(CheckoutTypes.CHECKOUT_LOGIN_REQUEST, checkoutLogin),
    takeLatest(CheckoutTypes.CHECKOUT_SIGNUP_REQUEST, checkoutSignup),
    // takeLatest(CheckoutTypes.CHECKOUT_REQUEST, checkoutPayment),
    takeLatest(SiteEventTypes.REQUEST, siteEvent),
    takeLatest(AvatarTypes.REQUEST, avatar),
    takeLatest(OfferTypes.FILE_REQUEST, offerFile),
    takeLatest(LogTypes.REQUEST, logs),
  ]);
}
